import { useState } from 'react';

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      name: 'Carlos Mendoza',
      location: 'Merced, CA',
      rating: 5,
      text: 'After a pipe burst in our home near Applegate Park, Indoor-Restore Services responded within the hour. They extracted all the water and had industrial dryers set up the same day. Our hardwood floors were saved thanks to their fast action. Truly the best water damage restoration team in Merced!',
      date: 'November 2024'
    },
    {
      name: 'Patricia Nguyen',
      location: 'Merced, CA – North Side',
      rating: 5,
      text: 'Our business on M Street suffered serious flood damage after the heavy rains. Indoor-Restore had us back open within days. They coordinated directly with our insurance adjuster and handled everything professionally. I recommend them to every business owner in Merced County.',
      date: 'October 2024'
    },
    {
      name: 'James Oliveira',
      location: 'Atwater, CA',
      rating: 5,
      text: 'I called Indoor-Restore at 2am after discovering water damage in my garage. They were at my Atwater home within 45 minutes. The crew was respectful, thorough, and kept me updated every step of the way. Outstanding 24/7 emergency service for the Central Valley!',
      date: 'September 2024'
    },
    {
      name: 'Rosa Gutierrez',
      location: 'Los Banos, CA',
      rating: 5,
      text: 'We had significant mold and water damage in our Los Banos rental property. Indoor-Restore Services handled the full remediation and restoration. They were knowledgeable about local building codes and worked efficiently. Our tenants were back in within two weeks. Highly recommend!',
      date: 'August 2024'
    },
    {
      name: 'Kevin Thao',
      location: 'Livingston, CA',
      rating: 5,
      text: 'After the storm caused roof damage and water intrusion in our Livingston home, Indoor-Restore came out immediately. They dried everything out, repaired the structural damage, and even helped us file our insurance claim. Exceptional service from a truly local Merced County company.',
      date: 'July 2024'
    }
  ];

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what property owners in Rialto and surrounding areas have to say about our water damage restoration services.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="flex justify-center mb-6">
              {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-3xl text-yellow-400"></i>
              ))}
            </div>
            
            <p className="text-xl text-gray-700 leading-relaxed mb-8 text-center italic">
              "{testimonials[activeIndex].text}"
            </p>
            
            <div className="text-center">
              <h4 className="text-lg font-bold text-gray-900">{testimonials[activeIndex].name}</h4>
              <p className="text-sm text-gray-600">{testimonials[activeIndex].location}</p>
              <p className="text-xs text-gray-500 mt-1">{testimonials[activeIndex].date}</p>
            </div>
          </div>

          <button 
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-2xl text-gray-700"></i>
          </button>
          
          <button 
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-2xl text-gray-700"></i>
          </button>

          <div className="flex justify-center mt-8 gap-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === activeIndex ? 'bg-teal-600 w-8' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <div className="text-center">
            <div className="text-5xl font-bold text-teal-600 mb-2">500+</div>
            <div className="text-gray-600">Properties Restored</div>
          </div>
          <div className="text-center">
            <div className="text-5xl font-bold text-teal-600 mb-2">4.9</div>
            <div className="text-gray-600">Average Rating</div>
          </div>
          <div className="text-center">
            <div className="text-5xl font-bold text-teal-600 mb-2">98%</div>
            <div className="text-gray-600">Customer Satisfaction</div>
          </div>
        </div>
      </div>
    </section>
  );
}
